module.exports = __webpack_public_path__ + "img/es-pc-step-1.1085dda0.png";